module.exports = __webpack_public_path__ + "static/media/image_2024-10-13_142649796-removebg-preview.a1016079.png";